import React, { useState, useEffect } from 'react';
import { Typography, Button, List, ListItem, Box, Card, CardContent, Grid } from '@mui/material';
import ArchivedSurveyModal from './ArchivedSurveyModal';
import axiosInstance from '../../axiosConfig';
import { colors } from '../../colors';

const ArchivedPage = () => {
  const [archivedSurveys, setArchivedSurveys] = useState([]); // Initialized as empty array
  const [selectedSurveyId, setSelectedSurveyId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const fetchArchivedSurveys = async () => {
      try {
        const response = await axiosInstance.get('/api/archived/surveys');
        setArchivedSurveys(response.data || []); // Ensure data is an array
      } catch (error) {
        console.error('Error fetching archived surveys:', error);
        setArchivedSurveys([]); // Set to empty array on error
      }
    };
    fetchArchivedSurveys();
  }, []);

  const handleViewDetails = (surveyId) => {
    setSelectedSurveyId(surveyId);
    setModalOpen(true);
  };

  return (
    <Box>
            {/* Title */}
            <Typography
                variant="h4"
                sx={{
                    color: colors.primaryApplicationText,
                    fontWeight: 'bold',
                    textAlign: 'center',
                    mb: 4,
                }}
            >
                Archived Surveys
            </Typography>

            {/* Archived Surveys List */}
            <Card elevation={3} sx={{ padding: '16px', borderRadius: '12px' }}>
                <CardContent>
                    {archivedSurveys && archivedSurveys.length > 0 ? (
                        <List>
                            {archivedSurveys.map((survey) => (
                                <ListItem
                                    key={survey.id}
                                    sx={{
                                        mb: 2,
                                        padding: '12px',
                                        borderRadius: '8px',
                                        backgroundColor: '#f9f9f9',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
                                        '&:hover': {
                                            backgroundColor: '#eaeff4',
                                        },
                                    }}
                                >
                                    {/* Survey Name */}
                                    <Grid container alignItems="center">
                                        <Grid item xs={8}>
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    fontWeight: '500',
                                                    color: colors.primaryApplicationText,
                                                }}
                                            >
                                                {survey.surveyName}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontStyle: 'italic',
                                                    color: colors.primaryBannerBlue,
                                                    marginTop: '4px',
                                                }}
                                            >
                                                ID: {survey.id}
                                            </Typography>
                                        </Grid>

                                        {/* View Details Button */}
                                        <Grid
                                            item
                                            xs={4}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'flex-end',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Button
                                                variant="outlined"
                                                onClick={() => handleViewDetails(survey.id)}
                                                sx={{
                                                    textTransform: 'none',
                                                    color: colors.primaryBannerBlue,
                                                    borderColor: colors.primaryBannerBlue,
                                                    '&:hover': {
                                                        backgroundColor: colors.primaryBannerBlue,
                                                        color: '#ffffff',
                                                    },
                                                }}
                                            >
                                                View Details
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <Typography
                            variant="body1"
                            color="textSecondary"
                            sx={{
                                textAlign: 'center',
                                padding: '20px',
                            }}
                        >
                            No archived surveys available.
                        </Typography>
                    )}
                </CardContent>
            </Card>

            {/* Archived Survey Modal */}
            {selectedSurveyId && (
                <ArchivedSurveyModal
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    surveyId={selectedSurveyId}
                />
            )}
        </Box>
  );
};
export default ArchivedPage;
